import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const Protected = (props) => {
    const naviget = useNavigate()
    const { Component } = props

    useEffect(() => {
        let login = localStorage.getItem("login")
        if (!login) {
            localStorage.setItem("loginStatus", "Por favor ingrese su usuario y contraseña para poder acceder")
            naviget("/",{replace: true})
        }
    }, [])

    return(
        <Component 
            stringify={props.stringify} 
            handleDataReceived={props.handleDataReceived} 
            formatoData={props.formatoData}
            //userSesion={props.userSesion}
            inspecciones={props.inspecciones}
            Component={Component}
        />
    )
}

export default Protected